import React, { Component } from "react";
import axios from "axios";
import { PrismButton } from "@prism-ui/react";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PermissionLevel from "../../data/PermissionLevel";
import Timeline from "./timeline";
import Event from "../Event/index";
import EventForm from "../Event/form";
import Unauthorized from "../Unauthorized";
import PageHeader from "../PageHeader";
import "./Dashboard.css";

export default class Dashboard extends Component {
  state = {
    loading: true,
    creating: false,
    editing: false,
    error: null,
    events: [],
    activeEvent: this.props.params.event_id,
    sidebarOpen: false,
  };

  componentDidMount() {
    this.loadEvents();
  }

  loadEvents() {
    var year = new Date().getFullYear();
    var chapter = this.props.currentUser.chapter_id;

    axios
      .get(`/api/events/${year}/${chapter}`)
      .then((response) => {
        let selEvent = parseInt(this.props.params.event_id) || null;
        if (!selEvent && response.data.length > 0) {
          selEvent = this.getNextEvent(response.data);
        }

        this.setState({
          loading: false,
          events: response.data,
          activeEvent: selEvent,
        });

        this.handleSelect(selEvent);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: "Unable to load events!",
        });
      });
  }

  setEvent(eventId) {
    this.setState({
      creating: false,
      editing: false,
      activeEvent: eventId,
    });
  }

  getNextEvent(events) {
    if (!events.length) {
      return null;
    }

    let nextEvent = events[0].id;
    let currDate = new Date();
    currDate.setHours(0, 0, 0, 0);

    events.find((e) => {
      let eventDate = new Date(e.date + " 00:00:00");
      if (eventDate >= currDate) {
        nextEvent = e.id;
        return true;
      }

      return false;
    });

    return nextEvent;
  }

  toggleSidebar() {
    this.setState({
      sidebarOpen: !this.state.sidebarOpen,
    });
  }

  isOfficer() {
    var userRole = this.props.currentUser.Role;
    return userRole.permission_level >= PermissionLevel.Officer;
  }

  handleDeleted(eventId) {
    var events = this.state.events.filter((e) => e.id !== eventId);

    let nextEvent = this.getNextEvent(events);

    this.setState({
      editing: false,
      events: events,
      activeEvent: nextEvent,
    });
  }

  // The API returns events ordered by date, so a created or re-dated item has to
  // be placed by date rather than appended.
  sortByDate(events) {
    return [...events].sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
  }

  handleCreated(event) {
    var events = this.sortByDate([...this.state.events, event]);

    this.setState({
      creating: false,
      events: events,
      activeEvent: event.id,
    });
  }

  handleUpdated(event) {
    var events = this.sortByDate(
      this.state.events.map((e) => (e.id === event.id ? event : e))
    );

    this.setState({
      editing: false,
      events: events,
      activeEvent: event.id,
    });
  }

  renderHeader = () => {
    return (
      <PageHeader title="CLEAR Dashboard">
        {this.isOfficer() ? (
          <PrismButton
            tone="primary"
            onPrismClick={() => {
              this.setState({ creating: true });
            }}
          >
            + New Item
          </PrismButton>
        ) : null}
      </PageHeader>
    );
  };

  render = () => {
    // Only Mentees and up can view this page
    let userLevel = this.props.currentUser.Role.permission_level;
    if (userLevel < PermissionLevel.Mentee) {
      return <Unauthorized />;
    }

    if (
      !this.state.creating &&
      !this.state.loading &&
      this.state.events.length === 0
    ) {
      return (
        <>
          {this.renderHeader()}
          <p className="clr:text-center text-lg">
            <br />
            No events or tasks yet
          </p>
        </>
      );
    }

    return (
      <div>
        {this.renderHeader()}

        <div className="dash">
          <section
            className={
              "dash-timeline " + (this.state.sidebarOpen ? "open" : "")
            }
          >
            <header>
              <PrismButton
                tone="primary"
                size="sm"
                spacing="compact"
                className="dash-timeline-toggle"
                setAriaLabel={this.state.sidebarOpen ? "Collapse timeline" : "Expand timeline"}
                onPrismClick={() => this.toggleSidebar()}
              >
                <FontAwesomeIcon
                  icon={this.state.sidebarOpen ? faChevronLeft : faChevronRight}
                ></FontAwesomeIcon>
              </PrismButton>
            </header>

            {!this.state.loading ? (
              <div className="dash-timeline-list">
                <Timeline
                  role={this.props.currentUser.Role}
                  event={this.state.creating || this.state.activeEvent}
                  events={this.state.events}
                  onSelect={(eventId) => this.setEvent(eventId)}
                />
              </div>
            ) : null}
          </section>

          <section className="dash-event">
            {this.state.creating && this.isOfficer() ? (
              <EventForm
                id={null}
                chapter={this.props.currentUser.chapter_id}
                onSaved={(event) => this.handleCreated(event)}
                onCancel={() => this.setState({ creating: false })}
              />
            ) : this.state.editing && this.isOfficer() ? (
              <EventForm
                id={this.state.activeEvent}
                chapter={this.props.currentUser.chapter_id}
                onSaved={(event) => this.handleUpdated(event)}
                onDeleted={(eventId) => this.handleDeleted(eventId)}
                onCancel={() => this.setState({ editing: false })}
              />
            ) : this.state.activeEvent ? (
              <div>
                {this.isOfficer() ? (
                  <>
                    <PrismButton
                      className="edit-btn"
                      tone="primary"
                      onPrismClick={() => this.setState({ editing: true })}
                    >
                      Edit Item
                    </PrismButton>
                    <hr />
                  </>
                ) : null}
                <Event
                  id={this.state.activeEvent}
                  role={this.props.currentUser.Role}
                />
              </div>
            ) : null}
          </section>
        </div>
      </div>
    );
  };
}
